// extracted by mini-css-extract-plugin
export default {"tab_bar":"styles_tab_bar__fp7KX","tab_bar_Big":"styles_tab_bar_Big__AdqQC"};